import { FCC } from "@types";
import { SpinnerUI } from "src/app/features/requests/features/loadings/spinner.ui";

export const LoaderStateUI: FCC<{
  isLoading: boolean;
  className?: string;
}> = ({ children, isLoading, className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            height: "100%",
            textAlign: "center",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SpinnerUI />
        </div>
      )}
      <div
        style={{
          transition: "opacity 0.3s",
          opacity: isLoading ? 0.2 : 1,
        }}
      >
        {children}
      </div>
    </div>
  );
};
